import React from 'react';

// Firebase
import { db } from "../../firebaseConfig";

// global
import { useAuth } from '../../AuthContext';

// redux
import { useAppSelector } from '../../redux/store';

// function fetchCallData
import { fetchCallMetrics } from './Function';
import getCurrentScreen from '../../Helper/GetScreen';

interface UserOption {
  id: string;
  name: string;
}

interface CallDistributionProps {
  // Add props here
  users: UserOption[];
  selectedUser: UserOption[];
  startTime: string | null;
  endTime: string | null;
}

interface CallMetrics {
  outboundCalls: number;
  missedCalls: number;
  connected: number;
  inboundCalls: number;
  outboundDuration: number;  // in seconds
  inboundDuration: number;   // in seconds
  totalDuration: number;     // in seconds
  durationZero: number;
  durationNotZero: number;
}

const TotalCallDuration: React.FC<CallDistributionProps> = ({ users, selectedUser, startTime, endTime }) => {

  const { userData, currentUser, isAdmin, isManager, isStaff } = useAuth();
  const currentScreen = getCurrentScreen(useAppSelector(state => state.screen.currentScreen), isAdmin, isManager, isStaff);

  // data state
  const [callMetrics, setCallMetrics] = React.useState<CallMetrics>();

  React.useEffect(() => {
    fetchCallMetrics({ db, userData, startTime: startTime || null, endTime: endTime || null, users, currentScreen, selectedUser })
      .then((data) => { setCallMetrics(data); })
      .catch((error) => console.error("Error fetching call logs:", error));
  }, [userData?.companyId, startTime, endTime, users, currentScreen, selectedUser]);

  // Helper Function to convert hours to hours, minutes and seconds
  const convertHours = (totalSeconds: number): string => {
    // Ensure we are working with an integer
    const roundedSeconds = Math.round(totalSeconds);

    const hrs = Math.floor(roundedSeconds / 3600);
    const mins = Math.floor((roundedSeconds % 3600) / 60);
    const secs = roundedSeconds % 60;

    return `${hrs} hrs : ${mins.toString().padStart(2, '0')} min : ${secs.toString().padStart(2, '0')} sec`;
  };

  const durationBoxes = [
    {
      title: 'Inbound + Outbound',
      duration: convertHours(callMetrics?.totalDuration || 0)
    },
    {
      title: 'Inbound',
      duration: convertHours(callMetrics?.inboundDuration || 0)
    },
    {
      title: 'Outbound',
      duration: convertHours(callMetrics?.outboundDuration || 0)
    }
  ];

  return (
    <div className="bg-white rounded-2xl">
      <h2
        className="text-lg text-black font-medium text-center mb-4"
        style={{
          fontFamily: "Montserrat",
        }}
      >Total Call Duration</h2>

      <div className="space-y-4 ">
        {durationBoxes.map((box, index) => (
          <div key={index} className="relative bg-zinc-100  rounded-2xl h-20">
            <div className="absolute left-0 rounded-tl-full rounded-br-full top-0 h-full w-5 bg-gradient-to-b bg-black to-transparent" />

            <div className="flex flex-col items-center justify-center h-full">
              <h3 className="text-sm font-medium text-center ">{box.title}</h3>
              <p className="text-xs text-gray-600 mt-1">{box.duration}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TotalCallDuration;